import React from 'react';
import { useNavigate } from 'react-router-dom';
import { TrendingUp, TrendingDown } from 'lucide-react';

const financeData = {
  income: 67000,
  expenses: 24500,
  pending: 15000,
  trend: '+15.3%',
};

export function FinanceWidget() {
  const navigate = useNavigate();

  return (
    <div className="space-y-4">
      {/* Main Chart Placeholder */}
      <div className="h-32 bg-gradient-to-r from-[#36CCD8]/10 to-[#2DB8C4]/10 rounded-lg flex items-end justify-around p-4">
        {[40, 65, 45, 80, 55, 70, 60].map((height, i) => (
          <div
            key={i}
            className="w-8 bg-[#36CCD8] rounded-t-sm transition-all hover:bg-[#2DB8C4]"
            style={{ height: `${height}%` }}
          />
        ))}
      </div>

      {/* Key Metrics */}
      <div className="grid grid-cols-3 gap-3">
        <div className="bg-green-50 rounded-lg p-3">
          <p className="text-xs text-gray-500 mb-1">Ingresos</p>
          <p className="text-lg font-bold text-green-600">${financeData.income.toLocaleString()}</p>
          <div className="flex items-center gap-1 mt-1">
            <TrendingUp className="w-3 h-3 text-green-500" />
            <span className="text-xs text-green-600">{financeData.trend}</span>
          </div>
        </div>
        <div className="bg-red-50 rounded-lg p-3">
          <p className="text-xs text-gray-500 mb-1">Gastos</p>
          <p className="text-lg font-bold text-red-600">${financeData.expenses.toLocaleString()}</p>
          <div className="flex items-center gap-1 mt-1">
            <TrendingDown className="w-3 h-3 text-red-500" />
            <span className="text-xs text-red-600">-5.2%</span>
          </div>
        </div>
        <div className="bg-orange-50 rounded-lg p-3">
          <p className="text-xs text-gray-500 mb-1">Pendiente</p>
          <p className="text-lg font-bold text-orange-600">${financeData.pending.toLocaleString()}</p>
          <p className="text-xs text-orange-600 mt-1">12 residentes</p>
        </div>
      </div>

      {/* Quick Action */}
      <button
        onClick={() => navigate('/financial-reports')}
        className="w-full py-2 text-sm font-medium text-[#36CCD8] hover:text-[#2DB8C4] hover:bg-[#36CCD8]/5 rounded-lg transition-colors"
      >
        Ver reporte completo →
      </button>
    </div>
  );
}

export default FinanceWidget;
